import { makeAutoObservable } from "mobx";
import { hexToRgb } from "../services/colorHelper";

export class ThemeStore {
  constructor() {
    makeAutoObservable(this);
  }

  primaryColor: string = "black";
  secondaryColor: string = "black";
  highlightColor: string = "black";
  hoverColor: string = "black";

  primaryColorRGB: string = "0, 0, 0";
  secondaryColorRGB: string = "0, 0, 0";
  highlightColorRGB: string = "0, 0, 0";
  hoverColorRGB: string = "0, 0, 0";

  setThemeColor(color: {
    primaryColor: string;
    secondaryColor: string;
    highlightColor: string;
    hoverColor: string;
  }): void {
    this.primaryColor = color.primaryColor;
    this.secondaryColor = color.secondaryColor;
    this.hoverColor = color.hoverColor;
    this.highlightColor = color.highlightColor;
    this.primaryColorRGB = hexToRgb(color.primaryColor);
    this.secondaryColorRGB = hexToRgb(color.secondaryColor);
    this.hoverColorRGB = hexToRgb(color.hoverColor);
    this.highlightColorRGB = hexToRgb(color.highlightColor);
  }
}
